export function getCurrentAdminLedgerId(subscription) {
  if (!subscription?.data?.provisionedAt) {
    return "trial";
  }

  const provisionedAt = subscription.data.provisionedAt.toDate?.() ?? subscription.data.provisionedAt;
  return new Date(provisionedAt).toISOString();
}
